/*
search by number -search by bib
collapse/hide
    Start collapsed (bib and placment with color coding) expand carrot.
    goal is to have all of one heat on a single page.
    Expand/collapse all button

counter for num of placements/all dancer by heat at top

Placement calculation -
    do the calc on individual as they are completely judged, or as the heat completes (heat complete button)
    updates the calc - introduce more shakey (send those to a follow up heat for finality)
    -updating in logic in existing service calls. (break into pieces)

Follow up heat judges screen.
-service calls

build a follow up email functionality, you will get an email if you need to come back. pay attention.
*/

import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Dropdown from 'react-dropdown';

//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
//core
import "primereact/resources/primereact.min.css";
//icons
import "primeicons/primeicons.css";
import 'react-dropdown/style.css';

const options = [1, 2, 3, 4, 5, 6, 7, 8,9, 10, 11];
const primary = "btn placement-button";

const clearButton = "btn placement-button clear row-action";
const scratchButton = "btn placement-button scratch row-action";
const hideScratchButton = "hide";
const defaultPlacement = "btn placement-button default";
const finalPlacement = "btn placement-button final";
let currentuser = "default";
const userjudgemap = new Map();
    

async function savejudgevote(selectedrow, newplacement) {
    await fetch('https://xwggndk5wl.execute-api.us-east-1.amazonaws.com/default/judges_service', {
        crossDomain: true,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Connection': 'keep-alive'
        },
        body: JSON.stringify({
            'method_name': 'post_judge_placement',
            'partition_key': selectedrow.heat,
            'sort_key': make_sortkey(selectedrow.bib_number, selectedrow.dancer_role, selectedrow.heat, userjudgemap.get(currentuser)),
            'bib_number': selectedrow.bib_number,
            'dancer_name': selectedrow.dancer_name,
            'dancer_role': selectedrow.dancer_role,
            'dancer_email': selectedrow.dancer_email,
            'heat': selectedrow.heat,
            'judge': userjudgemap.get(currentuser),
            'placement': newplacement,
        })
    }).then(response => {
        console.debug(response.status);
    });
}

async function get_dancers_for_heat(value) { 
    const heat = value.value; 
    const response = await fetch('https://xwggndk5wl.execute-api.us-east-1.amazonaws.com/default/judges_service', 
    { 
        crossDomain: true, 
        method: 'POST', 
        headers: { 
            'Content-Type': 'application/json', 
            'Connection': 'keep-alive' 
        }, 
        body: JSON.stringify({
             'method_name': 'get_all_dancers_for_a_heat', 
             'heat': heat, 
             'judge': userjudgemap.get(currentuser)
         }) }); 
    const data = await response.json(); 
    if (Array.isArray(data) && data.length !== 0)
        { 
            const expandedRows = {}; 
            data.forEach(dancer => { expandedRows[dancer.bib_number] = true; });
            this.setState({ dancers: data, heat: heat, loading: false, expandedRows }); 
        } else 
        { this.setState({ dancers: [], heat: heat, loading: false, expandedRows: {} }); } 
    } 

function countRemainingDancers() {
    const totalRows = this.state.dancers.length;
    const expandedCount = Object.keys(this.state.expandedRows || {}).length;
    return `  ${expandedCount}/${totalRows}`;
}


function make_sortkey(bib, role, heat, judge) {
    const sort_key = bib + "_" + role + "_" + heat + "_" + judge;
    return sort_key;
}

export default class HeatView extends Component {
    constructor(props) {
        super(props);
        currentuser = this.props.user
        this.filters = null;
       
        this.state = { 
            dancers: [],    
            heat: "1", 
            loading: true,
            currentDancerBib: "0",
            expandedRows: null,
            fullscreen: false,
         };
        this.onChangePlacement = this.onChangePlacement.bind(this);
        this.onRowToggle = this.onRowToggle.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.placementButtonsBodyTemplate = this.placementButtonsBodyTemplate.bind(this);
        this.allowExpansion = null;
        userjudgemap.set("sherie_502@yahoo.com", "sherie_carranza");
        userjudgemap.set("jfoote226@hotmail.com", "jerry_foote");
        userjudgemap.set("justin.mann0511@gmail.com", "justin_mann");
        userjudgemap.set("alesandrabull@gmail.com", "alesandra_bull");        
        userjudgemap.set("joanna@joannalucero.com", "joanna_lucero");
        userjudgemap.set("lucero.joanna@gmail.com", "joanna_lucero");
        userjudgemap.set("huynh.stefan@gmail.com", "stefan_huynh");
        userjudgemap.set("laineybuchignani@gmail.com", "elaine_buchignani");
    }
    async removejudgevote(value, selectedrow) 
    { 
        await fetch('https://xwggndk5wl.execute-api.us-east-1.amazonaws.com/default/judges_service', { 
            crossDomain: true, 
            method: 'POST', 
            headers: { 
                'Content-Type': 'application/json', 
                'Connection': 'keep-alive' 
            }, 
            body: JSON.stringify({ 
                'method_name': 'remove_judge_placement', 
                'partition_key': selectedrow.heat, 
                'sort_key': make_sortkey(selectedrow.bib_number, selectedrow.dancer_role, selectedrow.heat, userjudgemap.get(currentuser)),
            }) 
        }).then(response => { 
            let elems = document.querySelectorAll(".dancer_" + selectedrow.bib_number + " .final"); 
            Array.from(elems).forEach((el) => el.classList.remove('final')); 
            console.debug(response.status); });
            const updatedDancers = this.state.dancers.map(d => {
                if(d.bib_number === selectedrow.bib_number && d.placementjudge === selectedrow.placementjudge) {
                    return { ...d, judgesplacement: "" };  // Clear the vote
                }
                return d;
            });
            this.setState({ dancers: updatedDancers });
    }

    async componentDidMount() {
        const response = await fetch('https://xwggndk5wl.execute-api.us-east-1.amazonaws.com/default/judges_service', {
            crossDomain: true,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Connection': 'keep-alive'
            },
            body: JSON.stringify({
                'method_name': 'get_all_dancers_for_a_heat',
                'heat': '1',
                'judge': userjudgemap.get(currentuser)
            })
        })
        const body = await response.json();

        if(Array.isArray(body)) {
            const expandedRows = {};
            body.forEach(dancer => {expandedRows[dancer.bib_number] = true;});
            this.setState({ dancers: body, heat: this.state.heat, loading: false, expandedRows });
        } else {
            this.setState({ dancers: [], heat: this.state.heat, loading: false });
        }

        
    }
    onRowToggle(e){
        this.setState({ expandedRows: e.data });
    }

    renderDancerTableContainer(dancers, currentHeat, expandedRows, onRowToggle) {
        this.allowExpansion = dancers.length > 0;
        return (
            <div id="heattable" className={this.state.fullscreen ? "fullscreen" : ""}>
                <div className="heat">
                    <span id="tabelLabel" >Placement Heat: </span>
                    <Dropdown options={options} onChange={get_dancers_for_heat.bind(this)} value={{ label: options[currentHeat - 1] }} placeholder="Select a heat" />
                    <span id="remainingDancers">{countRemainingDancers.call(this)}</span>
                    <button className="btn btn-primary" onClick={() => this.setState({ fullscreen: !this.state.fullscreen })}> 
                        {this.state.fullscreen ? 'Collapse' : 'Full Screen'} </button>
                </div>
                {this.renderDancerTable(dancers, currentHeat, expandedRows, onRowToggle)}
            </div>
        );
    }

    getRowClassName(rowData) {
        // Replace 'some_field' and 'some_value' with your actual field and value
        return "dancer_" + rowData.bib_number;
    }

    renderDancerTable(dancers, currentHeat, expandedRows, onRowToggle) {
        return (
            <div id="heatTableContainer">
                <DataTable value={dancers} expandedRows={expandedRows} onRowToggle={onRowToggle} dataKey="bib_number"
                filters={this.filters} filterDisplay="row" stripedRows scrollable removableSort responsiveLayout="scroll" 
                scrollHeight="flex" rowExpansionTemplate={this.rowExpansionTemplate} rowClassName={this.getRowClassName}>
                    <Column expander={this.allowExpansion} style={{ width: '0rem' }} />
                    <Column field="bib_number" header="Bib" filter filterPlaceholder="Bib Search" sortable></Column>
                    <Column field="dancer_name" header="Name" sortable style={{ textAlign: 'center' }}></Column>
                </DataTable>
            </div>
        );
    }
    rowExpansionTemplate(data) {
        //
        return (
            <div className="p-3">
                <div id="heatTableContainerExpanded">
                    <DataTable value={[data]} >
                        <Column field="dancer_role" header="Role" sortable></Column>
                        <Column field="placement" header="Placement" body={this.placementButtonsBodyTemplate}></Column>
                  
                    </DataTable>
                </div>
            </div>
            

        );
    }
    
    placementButtonsBodyTemplate(data) {
        return (
            <div className="gap-3">
                <button type="button" className={data.judgesplacement === '2' ? finalPlacement : data.placement === '2' ? defaultPlacement : primary} onClick={e => this.onChangePlacement(e, data)}>2</button>
                <button type="button" className={data.judgesplacement === '3' ? finalPlacement : data.placement === '3' ? defaultPlacement : primary} onClick={e => this.onChangePlacement(e, data)}>3</button>
                <button type="button" className={data.judgesplacement === '4' ? finalPlacement : data.placement === '4' ? defaultPlacement : primary} onClick={e => this.onChangePlacement(e, data)}>4</button>
                <button type="button" className={data.judgesplacement === '5' ? finalPlacement : data.placement === '5' ? defaultPlacement : primary} onClick={e => this.onChangePlacement(e, data)}>5</button>
                <button type="button" className={data.judgesplacement === '6' ? finalPlacement : data.placement === '6' ? defaultPlacement : primary} onClick={e => this.onChangePlacement(e, data)}>6</button>
                <button type="button" className={clearButton} onClick={e => this.onChangePlacement(e, data)}>clear</button>
            </div>
        );
    }

    onChangePlacement(value, dancer) {
        let thisButton = value.currentTarget;        
        if (thisButton.innerHTML === 'clear') {
            this.removejudgevote(value, dancer);
        }
        else {
            let parent = thisButton.parentElement;
            let otherButtons = parent.children;
            for (let button in otherButtons) {
                if (button < otherButtons.length && !otherButtons[button].className.includes("row-action")) {
                    if(this.state.heat === 11)
                    {
                        if (!otherButtons[button].className.includes("final")) {
                            otherButtons[button].className = "btn placement-button";
                        }
                        else {
                            otherButtons[button].className = "btn placement-button default";
                        }
                    }
                    else{
                        if (!otherButtons[button].className.includes("default")) {
                            otherButtons[button].className = "btn placement-button";
                        }
                        else {
                            otherButtons[button].className = "btn placement-button default";
                        }
                    }
                }
                else {
                    break;
                }
            }
            if (!thisButton.className.includes("default")) {
                thisButton.className = "btn placement-button final";
            }
            else {
                thisButton.className = "btn placement-button default final";
            }
            let newplacement = thisButton.childNodes[0].data;
            
            const updatedDancers = this.state.dancers.map(d => {
                if (d.bib_number === dancer.bib_number && d.placementjudge === dancer.placementjudge) {   
                    return { ...d, judgesplacement: newplacement };
                }
                return d;
            });
            this.setState({ dancers: updatedDancers });
            savejudgevote(dancer, newplacement);
            
        }
    }

    render() {

        if (userjudgemap.has(currentuser)) {
            let contents = this.state.loading
                ? <p><em>Loading table data...</em></p>
                : this.renderDancerTableContainer(this.state.dancers, this.state.heat, this.state.expandedRows, this.onRowToggle);

            return (
                <div id="heatContainer">
                    {contents}
                </div>
            );
        }
        else {
            return (
                <div className='body-container'>Non-Judges cant see heat info! </div>
            );
        }
    }
}
